// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/catalog/interfaces/batch-retrieve-catalog-obj.proto
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Error } from "../../resources/error";
import { CatalogObject } from "../resources/datatypes";
import { InlineTypes } from "../resources/enums";
export const protobufPackage = "squareup.connect.v2.merchant_catalog.service";
function createBaseBatchRetrieveCatalogObjectsRequest() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsRequest",
        objectIds: [],
        includeRelatedObjects: undefined,
        includeCounts: undefined,
        catalogVersion: undefined,
        includeDeletedObjects: undefined,
        includeNestedObjects: undefined,
        includeCategoryPathToRoot: undefined,
    };
}
export const BatchRetrieveCatalogObjectsRequest = {
    $type: "squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsRequest",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.objectIds) {
            writer.uint32(10).string(v);
        }
        if (message.includeRelatedObjects !== undefined) {
            writer.uint32(32).bool(message.includeRelatedObjects);
        }
        if (message.includeCounts !== undefined) {
            writer.uint32(40).bool(message.includeCounts);
        }
        if (message.catalogVersion !== undefined) {
            writer.uint32(48).int64(message.catalogVersion);
        }
        if (message.includeDeletedObjects !== undefined) {
            writer.uint32(24).bool(message.includeDeletedObjects);
        }
        if (message.includeNestedObjects !== undefined) {
            writer.uint32(64).int32(message.includeNestedObjects);
        }
        if (message.includeCategoryPathToRoot !== undefined) {
            writer.uint32(72).bool(message.includeCategoryPathToRoot);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchRetrieveCatalogObjectsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.objectIds.push(reader.string());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.includeRelatedObjects = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.includeCounts = reader.bool();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.catalogVersion = longToNumber(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.includeDeletedObjects = reader.bool();
                    continue;
                case 8:
                    if (tag !== 64) {
                        break;
                    }
                    message.includeNestedObjects = reader.int32();
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.includeCategoryPathToRoot = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BatchRetrieveCatalogObjectsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBatchRetrieveCatalogObjectsRequest();
        message.objectIds = object.objectIds?.map((e) => e) || [];
        message.includeRelatedObjects = object.includeRelatedObjects ?? undefined;
        message.includeCounts = object.includeCounts ?? undefined;
        message.catalogVersion = object.catalogVersion ?? undefined;
        message.includeDeletedObjects = object.includeDeletedObjects ?? undefined;
        message.includeNestedObjects = object.includeNestedObjects ?? undefined;
        message.includeCategoryPathToRoot = object.includeCategoryPathToRoot ?? undefined;
        return message;
    },
};
function createBaseBatchRetrieveCatalogObjectsResponse() {
    return {
        $type: "squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsResponse",
        errors: [],
        objects: [],
        relatedObjects: [],
    };
}
export const BatchRetrieveCatalogObjectsResponse = {
    $type: "squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsResponse",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.errors) {
            Error.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.objects) {
            CatalogObject.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.relatedObjects) {
            CatalogObject.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBatchRetrieveCatalogObjectsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.errors.push(Error.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.objects.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.relatedObjects.push(CatalogObject.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return BatchRetrieveCatalogObjectsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBatchRetrieveCatalogObjectsResponse();
        message.errors = object.errors?.map((e) => Error.fromPartial(e)) || [];
        message.objects = object.objects?.map((e) => CatalogObject.fromPartial(e)) || [];
        message.relatedObjects = object.relatedObjects?.map((e) => CatalogObject.fromPartial(e)) || [];
        return message;
    },
};
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
